import { CreateOauth2IntegrationForChannel } from '@/connection/integrations/oauth';
import { serializeError } from '@/store/utils/serialize-error';
import { CreateOauth2Integration } from '@/types/registration.types';
import { ChannelSettingsReducerCreator } from '../types';

const createOauthIntegrationReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async (
      { channel, integration }: { channel: number; integration: CreateOauth2Integration },
      { rejectWithValue }
    ) => {
      try {
        const isOn = await CreateOauth2IntegrationForChannel(channel, integration);
        return isOn;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.oauthIntegration = action.payload;
      },
    }
  );
};

export default createOauthIntegrationReducer;
